// ==============================|| MENU ITEMS ||============================== //

import { NavItemType } from 'types';
import businessManagement from './businessManagement';
import calendar from './calendar';
import communications from './communications';
import contentManagement from './contentManagement';
import dashboard from './dashboard';
import reporting from './reportManagement';
import settings from './settings';
import system from './system';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, calendar, businessManagement, communications, contentManagement, reporting, system, settings]
};

export default menuItems;
